const ListOfProductCarouselConfig = [
    {
        span: 6,
        classes: "marginTop-48",
        height: "27px",
    },
    {
        classes: "marginTop-16",
        columns: [
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 2, height: "314px" },
        ],
    },
    {
        span: 6,
        classes: "marginTop-48",
        height: "27px",
    },
    {
        classes: "marginTop-16",
        columns: [
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 3, height: "314px" },
            { span: 2, height: "314px" },
        ],
    },
]

export default ListOfProductCarouselConfig
